<html xmlns="http://www.w3.org/1999/xhtml">

<head id="Head1" runat="server">
	<title>Workorder</title>
</head>
<style type="text/css">
	.UpperCase {
		font-weight: bold;
		font-size: 11px;
		text-transform: uppercase;
	}

	.ProperCase {
		font-size: 12px;
		text-transform: capitalize;
	}

	td,
	th {
		font-family: Arial;
		font-size: 10.0pt;
	}

	p.line_space {
		mso-style-parent: "";
		margin: 0in;
		margin-bottom: .0001pt;
		mso-pagination: widow-orphan;
		font-size: 10.0pt;
		mso-bidi-font-size: 10.0pt;
		font-family: Arial;
		text-align: justify;
		mso-fareast-font-family: "Arial";
		mso-bidi-font-family: "Arial";
		line-height: 120%
	}

	p.normal {
		mso-style-parent: "";
		margin: 0in;
		margin-bottom: .0001pt;
		mso-pagination: widow-orphan;
		font-size: 10.0pt;
		mso-bidi-font-size: 10.0pt;
		font-family: Arial;
		text-align: justify;
		mso-fareast-font-family: "Arial";
		mso-bidi-font-family: "Arial";
	}

	p.header {
		margin: 0in;
		margin-bottom: .0001pt;
		mso-pagination: widow-orphan;
		tab-stops: center 3.0in right 6.0in;
		font-size: 9.0pt;
		mso-bidi-font-size: 9.0pt;
		font-family: Verdana;
		mso-fareast-font-family: "Arial";
		mso-bidi-font-family: "Arial";
	}

	ol {
		font-size: 10.0pt;
		mso-bidi-font-size: 10.0pt;
		font-family: Arial;
		line-height: 110%;
		text-align: left
	}
	li::marker {
    color: black;
    font-size: 14px;
    }
	ul {
		font-size: 10.0pt;
		mso-bidi-font-size: 10.0pt;
		font-family: Arial;
		text-align: left;
	}
</style>

<body style='tab-interval:.5in; background-color: white !important;'>
	<form id="form1">
		<!-- <div>
			<h1>New workorder </h1>
			{{WorkorderFormsDetails['Candidate_FName']}}
			{{wofsetup.Candidate_FName}}
		</div> -->
		<div id="DivDoc" style="padding: 10px;">
			<p class="header" align=center><b>EXHIBIT A - WORK ORDER</b></p>
			<p class="header"><br />This Work Order Number <b>
					{{wofsetup.gci_id}}00-{{wofsetup.hR_ClientInfo_ID}}-00
				</b> is being entered into between Ascendion, Inc. ("Ascendion") and
				{{wofsetup.subtier_Company}} ("Contractor")
				pursuant to and in connection with the Consulting Services Agreement between Ascendion and
				Contractor (together with any and all Exhibits, Schedules, and Addenda to such Consultant Services
				Agreement, the "CSA"). This Work Order is subject to and governed by CSA, the terms of which are
				hereby incorporated herein by reference. Any capitalized term that is used but not defined in this
				Work Order shall have the meaning given to such term in the CSA.</p>
			<p class="header"><br /><b>To amend the CSA, this Work Order must (a) specifically indicate that it is
					amending the CSA, and (b) specifically identify the Section or Sections of the CSA that are being
					amended (an "Amendment"). With the exception of the terms of an Amendment, in the event of any
					conflict or inconsistency between the terms of this Work Order and the terms of the CSA, the terms
					of the Work Order shall govern and control.</b></p>

			<ol>
				<li *ngIf="isCandidateNameChecked" style="margin-bottom:5px;"><span class="UpperCase">NAME OF CONSULTANT</span>: <span
					class="ProperCase"> {{txtCandidateName}}</span></li>
			<li *ngIf="isContractorNameChecked" style="margin-bottom:5px;"><span class="UpperCase">NAME OF CONTRACTOR</span>: <span
					class="ProperCase">{{txtContractorName}}</span></li>

			<li *ngIf="clientName=='Bank of America' && isNameOfClientChecked" style="margin-bottom:5px;"><span class="UpperCase">NAME OF {{
					CPNY | uppercase }} CLIENT</span>: Bank of
				America</li>
			<li *ngIf="clientName !== 'Bank of America' && isNameOfClientChecked" style="margin-bottom:5px;"><span class="UpperCase">NAME OF
					{{ CPNY | uppercase }} CLIENT</span>: {{ txtNameOfClient | titlecase }}</li>
			<li *ngIf="isWork_decsChecked" style="margin-bottom: 5px;"><span class="UpperCase">NATURE OF WORK TO BE PERFORMED</span> (Specify
				in detail. Include description of
				any project or projects to be completed): <p>
					{{WorkDesc}}
				</p>
			</li>
			<li *ngIf="isProjectLocationChecked" style="margin-bottom: 5px;"><span class="UpperCase">PROJECT LOCATION</span>:
				{{txtProjectLocation}}
			</li>
			<li *ngIf="Recruiting_Direct=='Passthrough' && isDESIGNATION_OF_PASSTHROUGHChecked" style="margin-bottom: 5px;"><span
				class="UpperCase">DESIGNATION OF PASSTHROUGH</span> <u>&nbsp;&nbsp;&nbsp;<span
					style='font-size: 12.0pt; font-family: "Wingdings 2"; mso-ascii-font-family: "Times New Roman"; mso-fareast-font-family: "Times New Roman"; mso-hansi-font-family: "Times New Roman"; mso-bidi-font-family: "Times New Roman"; mso-ansi-language: EN-US; mso-fareast-language: EN-US; mso-bidi-language: AR-SA; mso-char-type: symbol; mso-symbol-font-family: "Wingdings 2"'><span
						style='mso-char-type: symbol; mso-symbol-font-family: "Wingdings 2"'>&#10003;</span></span>&nbsp;&nbsp;&nbsp;</u>
			<span class="UpperCase">OR STANDARD</span>
			<u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</u>
		</li>

		<li *ngIf="Recruiting_Direct !='Passthrough' && isDESIGNATION_OF_PASSTHROUGHChecked" style="margin-bottom: 5px;"><span
				class="UpperCase">DESIGNATION OF PASSTHROUGH</span>
			<u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</u> <span class="UpperCase">OR
				STANDARD</span>
			<u>&nbsp;&nbsp;&nbsp;<span
					style='font-size: 12.0pt; font-family: "Wingdings 2"; mso-ascii-font-family: "Times New Roman"; mso-fareast-font-family: "Times New Roman"; mso-hansi-font-family: "Times New Roman"; mso-bidi-font-family: "Times New Roman"; mso-ansi-language: EN-US; mso-fareast-language: EN-US; mso-bidi-language: AR-SA; mso-char-type: symbol; mso-symbol-font-family: "Wingdings 2"'><span
						style='mso-char-type: symbol; mso-symbol-font-family: "Wingdings 2"'>&#10003;</span></span>&nbsp;&nbsp;&nbsp;</u>
		</li>
		<li *ngIf="isStartDateChecked" style="margin-bottom: 5px;"><span class="UpperCase">ANTICIPATED ASSIGNMENT START DATE</span>:
			{{txtStartDate}}
		</li>
		<li *ngIf="isEndDateChecked" style="margin-bottom: 5px;"><span class="UpperCase">ANTICIPATED ASSIGNMENT END DATE*</span>:
			{{txtEndDate}}<br />
			<br />
			<p *ngIf="txtEndDate!=''">*NOTE:</p>{{txtEndDateNote}}
			 <!-- This Work Order will commence on the Actual Start Date and shall remain in effect until the
			date
			specified above or until work is completed to the satisfaction of {{CPNY}} or terminated pursuant
			to the Consulting Services Agreement. -->
		</li>
				<!-- <li *ngIf="Subtier_ST2_Effective_Date !='' || Subtier_ST2 !='' " style="margin-bottom: 5px;"><span
						class="UpperCase">PAY RATE AND FEES</span>:
						<table border="1" cellspacing="0" cellpadding="0"
                        style='border-collapse: collapse; border: none; mso-border-alt: solid black .5pt; mso-padding-alt: 0in 5.4pt 0in 5.4pt'>
						<tr>
							<th style="background-color: Black;">&nbsp;</th>
							<th style="background-color: Black; color: White">&nbsp;&nbsp; Effective Date &nbsp;&nbsp;</th>
							<th style="background-color: Black; color: White">&nbsp;&nbsp; {{CPNY}} Pay Rate to Contractor</th>
						</tr>
						<tr>
							<td style="padding: 5px;">Straight time (ST)</td>
							<td style="text-align: right; padding-right: 5px;">{{wofsetup.hR_Project_StartDate}} </td>
							<td style="padding: 5px;">{{wofsetup.hR_Subtier_ST}} ( <span
									class='UpperCase'>{{wofsetup.hR_Subtier_ST_Word}}</span> )
								{{wofsetup.hR_Subtier_ST_Units}} </td>
						</tr>
						<tr *ngIf="wofsetup.hR_Subtier_OT !='' ">
							<td style="padding: 5px;">Overtime (OT)</td>
							<td style="text-align: right; padding-right: 5px;">{{wofsetup.hR_Project_StartDate}} </td>
							<td style="padding: 5px;">{{wofsetup.hR_Subtier_OT}} ( <span
									class='UpperCase'>{{wofsetup.hR_Subtier_OT_Word}}</span> )
								{{wofsetup.hR_Subtier_OT_Units}} </td>
						</tr>
						<tr *ngIf="wofsetup.hR_Subtier_ST2_Effective_Date !='' || wofsetup.hR_Subtier_ST2 !='' ">
							<td style="padding: 5px;">Straight time (ST)</td>
							<td style="text-align: right; padding-right: 5px;">{{wofsetup.hR_Subtier_ST2_Effective_Date}}</td>
							<td style="padding: 5px;">{{wofsetup.hR_Subtier_ST2}} ( <span
									class='UpperCase'>{{wofsetup.hR_Subtier_ST2_Word}}</span> )
								{{wofsetup.hR_Subtier_ST2_Units}} </td>
						</tr>
						<tr *ngIf="wofsetup.hR_Subtier_OT2_Effective_Date !='' || wofsetup.hR_Subtier_OT2 !='' ">
							<td style="padding: 5px;">Overtime (OT)</td>
							<td style="text-align: right; padding-right: 5px;">{{wofsetup.hR_Subtier_OT2_Effective_Date}}</td>
							<td style="padding: 5px;">{{wofsetup.hR_Subtier_OT2}} ( <span
									class='UpperCase'>{{wofsetup.hR_Subtier_OT2_Word}}</span> )
								{{wofsetup.hR_Subtier_OT2_Units}} </td>
						</tr>


						<tr *ngIf="wofsetup.hR_Subtier_ST3_Effective_Date != '' || wofsetup.hR_Subtier_ST3 !='' ">
							<td style="padding: 5px;">Straight time (ST)</td>
							<td style="text-align: right; padding-right: 5px;">{{wofsetup.hR_Subtier_ST3_Effective_Date}}</td>
							<td style="padding: 5px;">{{wofsetup.hR_Subtier_ST3}} ( <span
									class='UpperCase'>{{wofsetup.hR_Subtier_ST3_Word}}</span> )
								{{wofsetup.hR_Subtier_ST3_Units}} </td>
						</tr>

						<tr *ngIf="wofsetup.hR_Subtier_OT3_Effective_Date !='' || wofsetup.hR_Subtier_OT3 !='' ">
							<td style="padding: 5px;">Overtime (OT)</td>
							<td style="text-align: right; padding-right: 5px;">
								{{wofsetup.hR_Subtier_OT3_Effective_Date}}
							</td>
							<td style="padding: 5px;">{{wofsetup.hR_Subtier_OT3}} ( <span
									class='UpperCase'>{{wofsetup.hR_Subtier_OT3_Word}}</span> )
								{{wofsetup.hR_Subtier_OT3_Units}} </td>
						</tr>

						<tr *ngIf="wofsetup.hR_Subtier_ST4_Effective_Date !='' || wofsetup.hR_Subtier_ST4 !='' ">
							<td style="padding: 5px;">Straight time (ST)</td>
							<td style="text-align: right; padding-right: 5px;">
								{{wofsetup.hR_Subtier_ST4_Effective_Date}}
							</td>
							<td style="padding: 5px;">{{wofsetup.hR_Subtier_ST4}} ( <span
									class='UpperCase'>{{wofsetup.hR_Subtier_ST4_Word}}</span> )
								{{wofsetup.hR_Subtier_ST4_Units}} </td>
						</tr>

						<tr *ngIf="wofsetup.hR_Subtier_OT4_Effective_Date !='' || wofsetup.hR_Subtier_OT4 !='' ">
							<td style="padding: 5px;">Overtime (OT)</td>
							<td style="text-align: right; padding-right: 5px;">
								{{wofsetup.hR_Subtier_OT4_Effective_Date}}
							</td>
							<td style="padding: 5px;">{{wofsetup.hR_Subtier_OT4}} ( <span
									class='UpperCase'>{{wofsetup.hR_Subtier_OT4_Word}}</span> )
								{{wofsetup.hR_Subtier_OT4_Units}} </td>
						</tr>
					</table>
				</li> -->

				<li *ngIf="isPAY_RATE_AND_FEES_Checked && (Subtier_ST2_Effective_Date =='' || Subtier_ST2 =='')" style="margin-bottom: 5px;"><span
						class="UpperCase">PAY RATE AND FEES</span>:
					<p class="normal"><b>Standard Time</b>:&nbsp; {{wofsetup.hR_Subtier_ST}} ( <span
							class='UpperCase'>{{wofsetup.hR_Subtier_ST_Word}}</span> )
						{{wofsetup.hR_Subtier_ST_Units}}. </p>
					<p class="normal" style='margin-top: 0.1in;'><b>Over time</b>:&nbsp;{{wofsetup.hR_Subtier_OT}} (
						<span class='UpperCase'>{{wofsetup.hR_Subtier_OT_Word}}</span> )
						{{wofsetup.hR_Subtier_OT_Units}}.
					</p>

				</li>
				<!-- <p *ngIf="wofsetup.hR_ClientInfo_Name =='mci' && isPAY_RATE_AND_FEES_Checked" class="normal" style='margin-top: 0.1in;'>
					All overtime must be approved by the Hiring Manager at MCI.
				</p> -->
				<br />

				<p *ngIf="isPAY_RATE_AND_FEES_Checked && txtPAY_RATE_AND_FEES!=''">*NOTE:</p>
				<ul *ngIf="isPAY_RATE_AND_FEES_Checked && txtPAY_RATE_AND_FEES!=''">
					<li style="margin-bottom: 5px;">
						{{txtPAY_RATE_AND_FEES}}
						<!-- All discounts and rebates assessed to {{CPNY}} by the Client shall
						be deducted from the amounts due to Contractor.
						The fees above are based on the {{CPNY}}'s bill rate to the client and shall be deducted
						accordingly from each Contractor
						invoice, which upon payment, by {{CPNY}}, of the reduced amount to Contractor, Contractor shall
						deem the Contractor invoice
						to be paid in full by {{CPNY}}. If the Client, at a later date, requires {{CPNY}} to increase
						the level of volume discount or
						increases the Authorized Service Provider fee or introduces any other fees, discounts or
						rebates, the differential
						will affect the contractor bill rate accordingly and or be deducted from amounts due to
						contractor. -->
					</li>
					<!-- <li *ngIf="wofsetup.hR_ClientInfo_ID == 'VE002' || wofsetup.hR_ClientInfo_ID == 'VE005' "
						style="margin-bottom: 5px;">Contractor hereby understands that Contractor is fully responsible
						for supplying Contractor's employee with a Pentium
						IV Laptop with at least 3.2 ghz and 1 gigabyte of RAM and 100 gigabyte hard drive and associated
						software applicable for
						completing the services (at a minimum Dual core processor with a min of 2.2 GHz,RAM 2 GB, HDD
						160 GB, DVD- reader, Gigabit Ethernet,
						WLAN, Windows XP Pro is a must(No vista or XP home) and ___________________) to be provided
						under
						this Work Order. Contractor's employee is to come to the engagement location fully prepared with
						such hardware and software
						from the first hour on the engagement. If Contractor's employee shows up at the engagement
						location without such hardware and
						software then {{CPNY}} shall provide such hardware and software at the expense of Contractor
						plus an additional administrative
						fee of $200.00 per occurrence. Contractor agrees to have such costs incurred by {{CPNY}},
						plus the administrative fee,
						automatically deducted and offset from the first and any subsequent invoices until such
						costs are fully repaid back to {{CPNY}}.
						At which time the Hardware and Software shall become the sole property of the
						Contractor. Contractor is fully liable for the
						functionality and maintenance of Contractor Hardware and Software. If Contractor is
						unable to correct an issue with Contractor's
						hardware or software during a project {{CPNY}} shall take the above steps as agreed
						and correct the situation in behalf of the
						Contractor.
						<br>
						<br>
						The ownership of the Hardware and Software in no way transfers any rights or
						ownership in confidential information
						or proprietary rights in any other information or data stored on the device that
						belongs to the Client or {{CPNY}}. At the end
						of the engagement the hardware and software are to be wiped and cleaned of
						all information related to the client, {{CPNY}} or
						the project, after a proper transfer of data and information to the
						Client or {{CPNY}} has occurred. The Contractor hereby
						certifies such actions have been taken by Contractor.
					</li> -->
				</ul>
				<li *ngIf="isCONSULTANT_TYPEChecked" style="margin-bottom: 5px;"><span class="UpperCase">CONSULTANT TYPE</span>: Select Consultant's
					relationship with Contractor.
					<br />
					<br />
					<input type="radio" id="houremployee" name="fav_language" [checked]="isCheckedHour"
						[disabled]="!docStatus" (change)="changeStatus($event)" value="Hourly Employee">
					&nbsp;
					<label for="houremployee">Hourly Employee</label> &nbsp; &nbsp; &nbsp; &nbsp;
					<input type="radio" id="salariemployee" name="fav_language" [checked]="isCheckedAnnum"
						[disabled]="!docStatus" (change)="changeStatus($event)" value="Salaried Employee"> &nbsp;
					<label for="salariemployee">Salaried Employee</label>
					<br />
					{{txtCONSULTANT_TYPE}}
					<!-- Under no circumstances is Contractor to use a 1099, consultant, subcontractor, or subtier of its own
					to perform Services for {{CPNY}}. Contractor shall only use its own
					W-2 Employees for providing Services to {{CPNY}} and its Client. Contractor shall not delegate or
					subcontract any services to a third party
					and shall not utilize any other corporate or entity for providing Services to {{CPNY}}. -->
				</li>

				<li *ngIf="isWAGE_RATE_PAID_TO_CONSULTANT_BY_CONTRACTORChecked" style="margin-bottom: 5px;"><span class="UpperCase">WAGE RATE PAID TO CONSULTANT BY
						CONTRACTOR</span>: {{txtWagePayRateNote}}
						<!-- {{wofsetup.subtier_Company}} discloses and confirms that it is paying the
					consultant -->
					<input name="txtPayrate" type="tel" id="txtPayrate" name="txtPayrate"
						(focusout)="onFocusOutEvent($event)" appTwoDigitDecimaNumber
						[disabled]="!IsTxtPayRate" [(ngModel)]="txtPayrate" style="text-align:right;" size="5">
					{{consltantPayDetails.Pay_Unit}}.
					<br />
					<br />
					{{txtWAGE_RATE_PAID_TO_CONSULTANT_BY_CONTRACTOR}}
					<!-- "Wage Rate Paid to Consultant by Contractor" means the direct wage rate Contractor pays its
					consultant resources for the Services performed on the
					applicable assignment as disclosed by contractor to {{CPNY}} on this applicable Work
					Order.This amount is exclusive of any benefits, per diem, taxes, immigration costs,
					expenses, or any other miscellaneous costs or incentives paid by Contractor.
					<br />
					<br />

					In the event of a {{CPNY}} or client audit {{wofsetup.subtier_Company}} agrees to provide proof
					of wage for the consultant as disclosed
					in this workorder. Such proof will include Pay stubs, W-2 and/or payroll
					records. -->
				</li>

				<li *ngIf="wofsetup.hR_ClientInfo_Name =='Procurestaff-PepsiCo' && isCRIMINAL_BACKGROUND_CHECKChecked" style="margin-bottom: 5px;"><span
						class="UpperCase">CRIMINAL BACKGROUND CHECK</span>:{{txtCRIMINAL_BACKGROUND_CHECK}}
						<!-- {{CPNY}} shall pay the cost for background
					check and drug screening up to a maximum $100.
					Vendor agrees that additional cost will be passed through by {{CPNY}} to Vendor as an expenses at
					actuals. -->
					<br />
				</li>
				<li *ngIf="wofsetup.hR_ClientInfo_Name !='Procurestaff-PepsiCo' && isCRIMINAL_BACKGROUND_CHECKChecked" style="margin-bottom: 5px;"><span
						class="UpperCase">CRIMINAL BACKGROUND CHECK</span>: {{txtCRIMINAL_BACKGROUND_CHECK}}
						<!-- The charges towards all client required
					Background Checks and Drug Tests will be
					deducted from the next payment due at actuals. -->
					<br />
				</li>
				<li *ngIf="isUNIQUE_TERMS_AND_CONDITIONSChecked" style="margin-bottom: 5px;" style="vertical-align: top;">
					<span *ngIf="CPNY =='Ascendion'" class="UpperCase">UNIQUE TERMS AND AMENDMENTS TO THE CSA
						APPLICABLE TO THIS WORKORDER :</span>
					<span *ngIf="CPNY !='Ascendion'" class="UpperCase">UNIQUE TERMS AND CONDITIONS :</span>
					<p
						*ngIf="wofsetup.hR_Project_Location_State =='Karnataka' || wofsetup.hR_Project_Location_State =='Kerala' ">
						<!-- Onsite Travel Cost - The travel cost would be as per notes to Schedule B of the Professional
						Software Services agreement -->
						{{UniqueTerms}}
					</p>
					<span
						*ngIf="wofsetup.hR_Project_Location_State !='Karnataka' && wofsetup.hR_Project_Location_State !='Kerala' ">
						<!-- If Client requires any pre-assignment training Contractor and Consultant shall NOT commence
						services unless and until Ascendion provides a final confirmation to start providing services
						under this Work Order. -->

						{{UniqueTerms}}
					</span>

				</li>
			</ol>



			<table border="1" cellspacing="0" cellpadding="0" style='width: 98.0%; border-collapse: collapse;'>
				<tr style="height: 40px">
					<td width="45%">
						<font face="Verdana" size="2">&nbsp; Company: {{wofsetup.subtier_Company}}
						</font>
					</td>
					<td width="55%">
						<font face="Verdana" size="2"> &nbsp; Company: {{CPNY}} </font>
					</td>
				</tr>
				<tr style="height: 40px">
					<td width="45%">
						<br />
						<font face="Verdana" size="2"> &nbsp; Signature:-</font>
						
					</td>
					<td width="55%">
						<br />
						<font face="Verdana" size="2"> &nbsp; Signature: </font>
						
					</td>
				</tr>
				<tr style="height: 40px">
					<td width="45%">
						<font face="Verdana" size="2">&nbsp; By:{{wofsetup.hR_Subtier_ContactPerson}}</font>
					</td>
					<td width="55%">
						<font face="Verdana" size="2">&nbsp; By:{{wofsetup.admin}} </font>
					</td>
				</tr>
				<tr style="height: 40px">
					<td width="45%">
						<font face="Verdana" size="2">&nbsp; Title:-</font>
					</td>
					<td width="55%">
						<font face="Verdana" size="2">&nbsp; Title:Operation Executive </font>
					</td>
				</tr>
				<tr style="height: 40px">
					<td width="45%">
						<font face="Verdana" size="2">&nbsp; Date:-</font>
					</td>
					<td width="55%">
						<font face="Verdana" size="2">&nbsp; Date: </font>
					</td>
				</tr>
			</table>
			&nbsp;
			<table *ngIf="docStatus">
				<tr>
					<td><input id="chkAgree" type="checkbox" name="chkAgree" [(ngModel)]="isChecked" (change)="checkValue(isChecked?'A':'B')" >&nbsp;<label
						style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;"	for="chkAgree">I agree that all Details are correct</label></td>
				</tr>
				<tr>
					<td>
						<div style="display: flex;padding-top: 10px;">
							<button type="button" ID="btnSubmit" class="obtn obtn-primary obtn-reg" Text="Submit"
								Style="font-weight: bold; font-style: italic"
								(click)="SaveWorkorder()">Submit</button>&nbsp;&nbsp;
							<button type="button" *ngIf="IsConsultant_Reject" ID="btnReject"  data-modalName="reject_notes_modal"
								Text="Reject" [ngClass]="!IsRejectBrnDisabled ? 'obtn obtn-outline obtn-reg' : 'obtn obtn-outline obtn-reg btnDisabled'" [disabled]="IsRejectBrnDisabled" (click)="RejectPopupOpen()"
								Style="font-weight: bold; font-style: italic">Reject</button>
						</div>
					</td>
				</tr>
				<td>&nbsp;</td>
			</table>
			<br />
			<br />
			<br />
		</div>
		
	</form>
	<div [ngClass]="RejectPopupclass" class="custom_modal notes_modal" id="reject_notes_modal">
		<div class="custom_modal_wrap">
			<div class="custom_modal_header">
				<h5 class="modal-title">Rejection Notes</h5>
				<button class="close" (click)="RejectPopupOpen()">
					<span>
						<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
							width="14" height="14" viewBox="0 0 14 14">
							<defs>
								<path id="x997k9vwqa"
									d="M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z" />
							</defs>
							<g fill="none" fill-rule="evenodd">
								<g>
									<g>
										<g>
											<g
												transform="translate(-1146 -528) translate(496 505) translate(1 17) translate(649 6)">
												<use fill="#4A4A4A" xlink:href="#x997k9vwqa" />
											</g>
										</g>
									</g>
								</g>
							</g>
						</svg>
					</span>
				</button>
			</div>
			<div class="custom_modal_body">
				<div *ngIf="RejectionNotesError" class="text-danger">
					<i class="fa fa-exclamation-circle" aria-hidden="true"></i>
					<b>Please enter Rejection Notes</b>
				</div>
				<div class="form_control required mb-3">
					<label for="">Notes <span>*</span></label>
					<textarea rows="4" [(ngModel)]="RejectionNotes" placeholder="Notes"></textarea>
				</div>
				<div class="confirmation_btn">
					<button class="close" (click)="RejectPopupOpen()">Cancel</button>
					<button class="confirm_btn" (click)="RejectWorkorder()">Save</button>
				</div>
			</div>
		</div>
	</div>
</body>

</html>